import { IResponseKasnet } from './../models/interfaces/kasnet-api.interface';
import {
	HttpClient,
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
	HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IResponseError } from '@pacifico/interfaces/generic-api.interface';
import { LoaderService } from '@pacifico/services/local/my-loader.service';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError, finalize, tap } from 'rxjs/operators';
import { PACICode, statusCode } from '../models/api';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	private _enQueued = 0;
	private _TIMEOUT = 100000;
	private _isFirst = true;
	private _isFirstTimeout;
	private _enErrorRes = false;

	constructor(private _loaderService: LoaderService, private router: Router) {}

	intercept(request: HttpRequest<HttpClient>, next: HttpHandler): Observable<HttpEvent<HttpClient>> {
		this.showLoader();
		return next.handle(request).pipe(
			tap((res) => {
				if (res instanceof HttpResponse) {
					if (res.body) {
						this.handleErrorResponse(res);
					}
				}
			}),
			catchError((error: HttpErrorResponse) => {
				const errorCode = String(error.error); // && error.error.code
				if (error instanceof HttpErrorResponse) {
					switch (error.status) {
						case statusCode.not_found:
							this.handle404Error(request, next, errorCode);
							break;
						case statusCode.bad_request:
							this.handle400Error(request, next, errorCode);
							break;
						case statusCode.unauthorized:
							return this.handle401Error(request, next, errorCode);
						case statusCode.forbidden:
							this.handle403Error(request, next, errorCode);
							break;
						case statusCode.internal_server_error:
							this.handle500Error(request, next, errorCode);
							break;
						default:
							this._loaderService.closeSessionModal('Ha ocurrido un error');
							console.log('Error Generico');
					}
				} else {
					console.log('Error Generico');
				}

				return throwError(error);
			}),
			finalize(() => this.hideLoader())
		);
	}

	private showLoader(): void {
		if (!this._enQueued) {
			this._loaderService.show();
		}
		this._enQueued++;

		// force just in case
		if (this._isFirst === true) {
			this._isFirstTimeout = setTimeout(() => {
				this._loaderService.hide();
			}, this._TIMEOUT);
			this._isFirst = false;
		}

		this._loaderService.show();
	}

	private hideLoader(): void {
		this._enQueued--;
		if (!this._enQueued) {
			if (this._isFirstTimeout) {
				clearInterval(this._isFirstTimeout);
			}
			this._loaderService.hide();
		}
	}

	private handle404Error(request: HttpRequest<HttpClient>, next: HttpHandler, errorCode: string) {
		switch (errorCode) {
			case PACICode.INVALID_USER_PASSWORD:
				void this.router.navigate(['/product-not-found'], { replaceUrl: true });
				break;
			default:
				console.log('Error Generico : 404');
		}

		return next.handle(request);
	}

	private handle400Error(request: HttpRequest<HttpClient>, next: HttpHandler, errorCode: string) {
		switch (errorCode) {
			case PACICode.INVALID_CAPTCHA:
			case PACICode.INVALID_JWT:
				break;
			default:
				console.log('Error Generico');
		}
		return next.handle(request);
	}

	private handle401Error(request: HttpRequest<HttpClient>, next: HttpHandler, errorCode: string) {
		if (request.url.includes('/security/logout')) {
			void this.router.navigate(['/']);
			return next.handle(request);
		}

		switch (errorCode) {
			case PACICode.INVALID_USER_PASSWORD:
				break;
			case PACICode.INVALID_JWT:
				break;
			case PACICode.INVALID_CAPTCHA:
				break;
			default:
		}
		return next.handle(request);
	}

	private handle403Error(request: HttpRequest<HttpClient>, next: HttpHandler, errorCode: string) {
		this._loaderService.hide();
		// this._loaderService.closeSessionModal('Su sesión ha terminado');
		return next.handle(request);
	}

	private handle500Error(request: HttpRequest<HttpClient>, next: HttpHandler, errorCode: string) {
		// this.modalService.alert(generalError);
		console.log(`Error Generico : ${errorCode}`);
		return next.handle(request);
	}

	private handleErrorResponse(res: HttpResponse<IResponseError | IResponseKasnet>) {
		if (res.body && !(res.body as IResponseKasnet).mensajeKasnet) {
			const response = res.body as IResponseError;
			//manejo de respuesta fallida del servidor v2
			if (response.error !== undefined && response.error) {
				if (!this._enErrorRes) {
					this._enErrorRes = this._loaderService.showAlertOnError('Ocurrio un Error, intente mas tarde');
				}
			} else if (response.errorType !== undefined) {
				if (!this._enErrorRes) {
					this._enErrorRes = this._loaderService.closeSessionModal('Su sesión ha terminado');
				}
			} else {
				this._enErrorRes = this._enErrorRes ? false : this._enErrorRes;
			}
		}
	}
}
